require("-!/var/lib/cright-webapp/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!sass-loader!/var/lib/cright-webapp/node_modules/bootstrap-sass-loader/bootstrap-sass-styles.loader.js!/var/lib/cright-webapp/src/theme/bootstrap.config.prod.js");
require("-!/var/lib/cright-webapp/node_modules/bootstrap-sass-loader/bootstrap-sass-scripts.loader.js!/var/lib/cright-webapp/src/theme/bootstrap.config.prod.js");


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass-loader/index.loader.js!./src/theme/bootstrap.config.prod.js
// module id = 895
// module chunks = 1